(function () {
    'use strict';

    angular
        .module('app.manualPosts')
        .factory('manualPostsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getManualPosts(params, loader) {
                    var url_getManualPosts = $rootScope.apiUrl + 'admin/getManualPosts';
                    return handleRequest(url_getManualPosts, 'POST', params, loader);
                }

                function addManualPost(params, loader) {
                    var url_addManualPost = $rootScope.apiUrl + 'admin/addManualPost';
                    return handleRequest(url_addManualPost, 'POST', params, loader);
                }

                function searchPostByURL(param, loader) {
                    var url = $rootScope.apiUrl + 'discover/searchPostByUrl?url=' + param;
                    return handleRequest(url, 'GET', null, loader);
                }

                service.getManualPosts = getManualPosts;
                service.addManualPost = addManualPost;
                service.searchPostByURL = searchPostByURL;

                return service;
            }
        ]);
})();
